import { render } from "./SimilarSlider.vue?vue&type=template&id=39e2f1a4&scoped=true"
import script from "./SimilarSlider.vue?vue&type=script&lang=js"
export * from "./SimilarSlider.vue?vue&type=script&lang=js"

import "./SimilarSlider.vue?vue&type=style&index=0&id=39e2f1a4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39e2f1a4"]])

export default __exports__